/**
 * Важно!!! Путь должен начинаться с '/' или 'https://'
 * Важно!!! Путь не должен заканчиваться '/'
 * http://domain.name - правильно
 * http://domain.name/uri - правильно
 * http://domain.name/uri/ - НЕ правильно
 * /uri/ - НЕ правильно
 * /uri - правильно
 */
export const environment = {
    production: true,
    hmr: false,
    baseUrl: 'https://ru.ge-co.io',
    env: 'production-ru',
    gMapApiKey: 'AIzaSyCz5iS1OOsPRFifhODTGm9elD84e-aMN90',
    posBaseUrl: 'https://api-pos.ru.ge-co.io',
    livetrackingBaseUrl: 'https://api-track.ru.ge-co.io',
    widgetBaseUrl: '',
    qrMenuBaseUrl: '',
    kioskBaseUrl : 'https://kiosk.getit.rest',
    kioskSettingsBaseUrl : 'https://kiosk.getit.rest',
    kioskVPNBaseUrl : 'https://api-kiosk-vpn.getit.rest',
    kioskMonitoringBaseUrl: 'https://kiosk-cc.getit.rest',
    contentManagerPath: '',
    kioskSettingsPath: '',
    kioskControlCenterPath: '',
    lastHashCommit : '0e013bbdc2ff417af047ef3c8cf010bbf9e733bd',
    publishedFor:"production",
    enableRelatedProductsV3: false
};
